import { render, staticRenderFns } from "./BaseResourceAssociationDataTable.vue?vue&type=template&id=03909e0e&scoped=true"
import script from "./BaseResourceAssociationDataTable.vue?vue&type=script&lang=ts"
export * from "./BaseResourceAssociationDataTable.vue?vue&type=script&lang=ts"
import style0 from "./BaseResourceAssociationDataTable.vue?vue&type=style&index=0&id=03909e0e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03909e0e",
  null
  
)

export default component.exports